import { combineReducers } from "redux";
import navigationReducer from "./navigationReducer";
import userReducer from "./userReducer";
import clientReducer from "./clientReducer";
import matterReducer from "./matterReducer";
import requestReducer from "./requestReducer";
import globalDialogReducer from "./globalDialogReducer";
import customColumnsReducer from "./customColumnsReducer";
import documentReducer from "./documentReducer";
import shareReducer from "./shareReducer";
import noteReducer from "./noteReducer";
import multiselectReducer from "./multiselectReducer";
import globalReducer from "./globalReducer";
import globalSnackbarReducer from "./globalSnackbarReducer";
import paginationReducer from "./paginationReducer";
import homepageReducer from "./homepageReducer";
import tenantReducer from "./tenantReducer";
import jobProgressReducer from "./jobProgressReducer";
import ocrJobProgressReducer from "./ocrJobProgressReducer";
import searchReducer from "./searchReducer";
import adminReducer from "./adminReducer";
import permissionsReducer from "./permissionsReducer";
import clioIntegrationReducer from "./clioIntegrationReducer";
import userSettingsReducer from "./userSettingsReducer";
import globalSearchbarReducer from "./globalSearchbarReducer";
import developerOverridesReducer from "./developerOverridesReducer";
import tableSortingReducer from "./tableSortingReducer";
import searchAuditReducer from "./searchAuditReducer";
import reactDialogReducer from "./reactDialogReducer";
import browserLocalstorageReducer from "./browserLocalstorageReducer";

import { USER_LOGGED_OUT } from "../actions/types";
import whatsNewReducer from "./whatsNewReducer";
import documentCompareReducer from "./documentCompareReducer";
import trashReducer from "./trashReducer";
import archiveReducer from "./archiveReducer";
import tagReducer from "./tagReducer";

export default () => {
	const rootReducer = (state, action) => {
		if (action.type === USER_LOGGED_OUT) {
			//reset all reducer states to initial state
			const clearStateOnLogout = {
				tableSorting: state.tableSorting,
			};
			return appReducer(clearStateOnLogout, action);
		}

		return appReducer(state, action);
	};
	// please try to keep this in alphabetical order
	const appReducer = combineReducers({
		archive: archiveReducer,
		trash: trashReducer,
		admin: adminReducer,
		browserLocalstorage: browserLocalstorageReducer,
		client: clientReducer,
		clioIntegration: clioIntegrationReducer,
		currentPage: navigationReducer,
		customColumns: customColumnsReducer,
		developerOverrides: developerOverridesReducer,
		document: documentReducer,
		documentCompare: documentCompareReducer,
		global: globalReducer,
		globalDialog: globalDialogReducer,
		globalSearchbar: globalSearchbarReducer,
		homepage: homepageReducer,
		jobProgress: jobProgressReducer,
		matter: matterReducer,
		multiselect: multiselectReducer,
		note: noteReducer,
		ocrJobProgress: ocrJobProgressReducer,
		pagination: paginationReducer,
		permissions: permissionsReducer,
		reactDialog: reactDialogReducer,
		request: requestReducer,
		search: searchReducer,
		searchAudit: searchAuditReducer,
		share: shareReducer,
		snackbar: globalSnackbarReducer,
		tableSorting: tableSortingReducer,
		tags: tagReducer,
		tenant: tenantReducer,
		user: userReducer,
		userSettings: userSettingsReducer,
		whatsNew: whatsNewReducer,
	});

	return rootReducer;
};
